"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import va from "@vercel/analytics";
import { Analytics } from "@vercel/analytics/react";
import { useLocalState } from "@travel/shared/hooks";
import { APP_MODE } from "@travel/shared/types";
import { isClient, isDev, isLocalServer } from "@travel/shared/utils";
import { getAnalytics, setupAnalyticsReplay, getAnalyticsReplay, } from "@travel/shared/utils";
import { useConfig } from "../use-config/use-config";
//@TODO: Refactor! These libs should not allow circular deps
import { useGlobalSearchParams } from "../../global/data-access/use-global-search-params/use-global-search-params";
function computeAnalayticsID(id) {
    return typeof id === "string" ? "".concat(APP_MODE, ":").concat(id) : id;
}
var SENSITIVE_PARAMS = ["email", "userId", "bookingId", "stack"];
export function AnalyticsProvider(_a) {
    var children = _a.children, trackers = _a.trackers;
    var _b = __read(useLocalState("travel__analytics--tracking-allowed", true), 1), isTrackAllowed = _b[0];
    var pathname = usePathname();
    var searchParams = useSearchParams();
    var track = useAnalytics().track;
    var trackRef = useRef(track);
    var isMountedRef = useRef(false);
    useEffect(function () {
        track("init");
    }, []);
    useEffect(function () {
        var _a;
        var query = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString()) || "";
        var url = (pathname || "") + (query ? "?".concat(query) : "");
        trackRef.current("navigation:page");
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: "pageview", url: url });
    }, [pathname, searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString()]);
    useEffect(function () {
        trackRef.current = track;
    }, [track]);
    useEffect(function () {
        var e_1, _a;
        if (isMountedRef.current)
            return;
        isMountedRef.current = true;
        setupAnalyticsReplay();
        var handleOnError = function (event, source, lineno, colno, error) {
            try {
                trackRef.current("GLOBAL:ERROR", {
                    event: JSON.stringify(event || ""),
                    source: source,
                    lineno: lineno,
                    colno: colno,
                    error: typeof error === error ? error : error === null || error === void 0 ? void 0 : error.message,
                    type: error === null || error === void 0 ? void 0 : error.type,
                    json: JSON.stringify({
                        event: event,
                        source: source,
                        lineno: lineno,
                        colno: colno,
                        error: error,
                    }),
                });
            }
            catch (_a) { }
        };
        window.addEventListener("error", handleOnError);
        if (trackers === null || trackers === void 0 ? void 0 : trackers.length) {
            try {
                for (var trackers_1 = __values(trackers), trackers_1_1 = trackers_1.next(); !trackers_1_1.done; trackers_1_1 = trackers_1.next()) {
                    var tracker = trackers_1_1.value;
                    if (tracker.iframe) {
                        var id = "".concat(tracker.name.toLowerCase(), "-analytics");
                        var el = document.getElementById(id);
                        if (el)
                            return;
                        var trackerEl = document.createElement("div");
                        trackerEl.id = id;
                        trackerEl.innerHTML = tracker.code;
                        document.body.appendChild(trackerEl);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (trackers_1_1 && !trackers_1_1.done && (_a = trackers_1.return)) _a.call(trackers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return function () {
            window.removeEventListener("error", handleOnError);
        };
    }, []);
    return (_jsxs(_Fragment, { children: [children, _jsx(Analytics, { beforeSend: function (event) {
                    if (!isTrackAllowed)
                        return null;
                    var url = new URL(event.url);
                    SENSITIVE_PARAMS.forEach(function (param) { return url.searchParams.delete(param); });
                    return __assign(__assign({}, event), { url: url.toString() });
                } })] }));
}
export function useAnalytics() {
    var _this = this;
    var partnerID = useConfig().partnerID;
    var _a = __read(useGlobalSearchParams(), 1), _b = _a[0], campaign = _b.campaign, cid = _b.cid, ad = _b.ad, vanity = _b.vanity;
    var getBaseTraits = useCallback(function (traits) {
        var baseTraits = __assign(__assign({}, traits), { partnerId: partnerID, projectId: partnerID, url: isClient ? window.location.href : undefined });
        if (campaign) {
            baseTraits.campaign = campaign;
            baseTraits.affiliateId = campaign;
        }
        if (ad) {
            baseTraits.adId = ad;
        }
        if (cid) {
            baseTraits.cid = cid;
            baseTraits.campaignId = cid;
        }
        if (vanity) {
            baseTraits.vanity = vanity;
        }
        for (var trait in baseTraits) {
            var value = baseTraits[trait];
            var type = typeof value;
            if (value === null ||
                type === "string" ||
                type === "number" ||
                type === "boolean") {
                if (!value) {
                    delete baseTraits[trait];
                }
            }
            else if (value) {
                if (Array.isArray(value) && !value.length) {
                    delete baseTraits[trait];
                }
                else {
                    try {
                        baseTraits[trait] = JSON.stringify(value);
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        }
        return baseTraits;
    }, [partnerID, campaign, ad, cid]);
    var identify = useCallback(function (id, traits, options) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.all([getAnalytics(), getAnalyticsReplay()]).then(function (_a) {
                    var _b;
                    var _c = __read(_a, 2), _d = __read(_c[0], 1), analytics = _d[0], replay = _c[1];
                    traits = getBaseTraits(traits);
                    (_b = replay === null || replay === void 0 ? void 0 : replay.identify) === null || _b === void 0 ? void 0 : _b.call(replay, id, traits);
                    return analytics.identify(id, traits, options);
                })];
        });
    }); }, [getBaseTraits]);
    var page = useCallback(function (category, name, traits, options) {
        return isLocalServer
            ? Promise.resolve()
            : getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.page(category, name, getBaseTraits(traits), options);
            });
    }, [getBaseTraits]);
    var track = useCallback(function (id, traits, options) {
        var _a;
        var analyticsID = computeAnalayticsID(id);
        var data = getBaseTraits(traits);
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(__assign(__assign({}, data), { event: analyticsID }));
        try {
            va.track(analyticsID, data);
        }
        catch (error) {
            console.error(error);
        }
        try {
            getAnalyticsReplay()
                .then(function (logrocket) {
                if (isDev) {
                    console.log("track logrocket", analyticsID, data);
                }
                logrocket.track(analyticsID, data);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        catch (error) {
            console.error(error);
        }
        return isLocalServer
            ? Promise.resolve()
            : getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.track(analyticsID, data, options);
            });
    }, [getBaseTraits]);
    var trackClick = useCallback(function (id, traits, options) {
        return isLocalServer
            ? Promise.resolve()
            : getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.trackClick(computeAnalayticsID(id), getBaseTraits(traits), options);
            });
    }, [getBaseTraits]);
    var trackLink = useCallback(function (id, traits, options) {
        return isLocalServer
            ? Promise.resolve()
            : getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.trackLink(computeAnalayticsID(id), getBaseTraits(traits), options);
            });
    }, [getBaseTraits]);
    var trackSubmit = useCallback(function (id, traits, options) {
        return isLocalServer
            ? Promise.resolve()
            : getAnalytics().then(function (_a) {
                var _b = __read(_a, 1), analytics = _b[0];
                return analytics.trackSubmit(computeAnalayticsID(id), getBaseTraits(traits), options);
            });
    }, [getBaseTraits]);
    return {
        identify: identify,
        page: page,
        track: track,
        trackClick: trackClick,
        trackLink: trackLink,
        trackSubmit: trackSubmit,
    };
}
